import styled from "styled-components";
import { Button, Flex, Type } from "discover.medical.react-component-library";

export const DrugInteractionCheckerHeader = styled(Flex)`
  padding: ${({ theme }) => theme.space.lg} 0 ${({ theme }) => theme.space.md};
`;

export const DrugInteractionInputContainer = styled.form`
  padding: ${({ theme }) => theme.space.lg} ${({ theme }) => theme.space.xl};
  background: ${({ theme }) => theme.colors.gray200};
  border-radius: ${({ theme }) => theme.border.radius.sm};

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: ${({ theme }) => theme.space.xxl} 3.5rem;
  }
`;

export const DrugInteractionCheckerLegend = styled(Type)`
  white-space: normal;
`;

export const DrugInteractionCheckerRow = styled(Flex)`
  margin: auto auto ${({ theme }) => theme.space.sm};

  .react-autosuggest__suggestions-container {
    max-height: 50vh;
  }
`;

export const DrugInteractionCheckerRemoveButton = styled(Button)`
  padding: ${({ theme }) => theme.space.sm};
`;

export const DrugInteractionCheckerAddButton = styled(Button)`
  padding: ${({ theme }) => theme.space.sm};
  padding-left: 0;
  font-size: ${({ theme }) => theme.font.size.sm};
`;

export const DrugInteractionCheckButton = styled(Button)`
  display: block;
  width: 16rem;
  margin: 0 auto;
  font-size: ${({ theme }) => theme.font.size.lg};
`;

export const DrugInteractionResetButton = styled(Button)`
  padding: ${({ theme }) => theme.space.sm};
  font-size: ${({ theme }) => theme.font.size.sm};
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding-right: 0;
  }
`;
